import Vue from 'vue';

import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import VeeValidate from 'vee-validate';
import VeeValidateConfig from '@/vee-validate-config';
Vue.use(VeeValidate, VeeValidateConfig);

import bemNameGenerator from 'shared-lib/mixins/bemNameGenerator';
Vue.mixin(bemNameGenerator);

import VueClipboard from 'vue-clipboard2'; // https://github.com/Inndy/vue-clipboard2
Vue.use(VueClipboard);

// styles
import '@/styles/main.scss';

import(/* webpackChunkName: "icons-svg" */ '@/icons-svg');

// Internationalization
import { i18n } from '@/locale';
import ElementLocale from 'element-ui/lib/locale';
// configure element-ui language
ElementLocale.i18n((key, value) => i18n.t(key, value));


// Cherry pick element-ui
// **REMEMBER** to import appropriate styles in src/styles/element-ui.scss
import Loading from 'element-ui/lib/loading';
Vue.use(Loading);

import Pagination from 'element-ui/lib/pagination';
Vue.use(Pagination);

import Select from 'element-ui/lib/select';
Vue.use(Select);

import Option from 'element-ui/lib/option';
Vue.use(Option);

import Switch from 'element-ui/lib/switch.js';
Vue.use(Switch);

import Slider from 'element-ui/lib/slider.js';
Vue.use(Slider);

import Card from 'element-ui/lib/card';
Vue.use(Card);

import Input from 'element-ui/lib/input';
Vue.use(Input);

import Tooltip from 'element-ui/lib/tooltip';
Vue.use(Tooltip);

import Tabs from 'element-ui/lib/tabs';
Vue.use(Tabs);

import TabPane from 'element-ui/lib/tab-pane';
Vue.use(TabPane);

import CheckboxGroup from 'element-ui/lib/checkbox-group';
Vue.use(CheckboxGroup);

import Checkbox from 'element-ui/lib/checkbox';
Vue.use(Checkbox);

import Popover from 'element-ui/lib/popover';
Vue.use(Popover);

import Button from 'element-ui/lib/button';
Vue.use(Button);

import Dropdown from 'element-ui/lib/dropdown';
Vue.use(Dropdown);
import DropdownMenu from 'element-ui/lib/dropdown-menu';
Vue.use(DropdownMenu);
import DropdownItem from 'element-ui/lib/dropdown-item';
Vue.use(DropdownItem);

import Alert from 'element-ui/lib/alert';
Vue.use(Alert);

import Dialog from 'element-ui/lib/dialog';
Vue.use(Dialog);

import DatePicker from 'element-ui/lib/date-picker';
Vue.use(DatePicker);

import Tag from 'element-ui/lib/tag';
Vue.use(Tag);

import VueMq from 'vue-mq';

Vue.use(VueMq, {
    breakpoints: {
        xs: 640,
        sm: 768,
        md: 1024,
        lg: 1280,
        xl: Infinity,
    },
});


Vue.config.productionTip = false;

// allow clipboard in modals
VueClipboard.config.autoSetContainer = true;

export { Vue, i18n };
